import { NgModule } from '@angular/core';

import { TermsRoutingModule } from './terms-routing.module';
import { TermsComponent } from './terms.component';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { CustomizationService } from 'src/services/customization.service';
import { PageLayoutModule } from 'src/app/belender/page-layout/page-layout.module';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MaterialModule } from 'src/app/shared/modules/materia.module';


@NgModule({
  declarations: [TermsComponent],
  imports: [
    TermsRoutingModule,
    MatProgressSpinnerModule,
    PageLayoutModule,
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MaterialModule
  ],
  providers: [
    CustomizationService
  ],
  exports: [TermsComponent]
})
export class TermsModule { }
